import { HistoryPesee } from './historyService';
import { ExportField } from '@/components/export/FieldSelector';

// Configuration des champs disponibles pour l'export
export const getAvailableExportFields = (): ExportField[] => {
  return [
    // === INFORMATIONS DE BASE (Requis) ===
    {
      key: 'reference',
      label: 'Référence',
      category: 'Informations de base',
      required: true,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.reference || weighing.référence || `#${weighing.id}`
    },
    {
      key: 'date_heure',
      label: 'Date et Heure',
      category: 'Informations de base',
      required: true,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => new Date(weighing.date_heure).toLocaleString('fr-FR')
    },
    {
      key: 'statut',
      label: 'Statut',
      category: 'Informations de base',
      required: true,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.statut
    },
    {
      key: 'type_pesee',
      label: 'Type de Pesée',
      category: 'Informations de base',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.type_pesee || 'N/A'
    },

    // === PRODUIT ===
    {
      key: 'produit_nom',
      label: 'Nom du Produit',
      category: 'Produit',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.produit_info?.nom || weighing.produit || 'N/A'
    },
    {
      key: 'produit_code',
      label: 'Code Produit',
      category: 'Produit',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.produit_info?.code || 'N/A'
    },
    {
      key: 'produit_categorie',
      label: 'Catégorie Produit',
      category: 'Produit',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.produit_info?.categorie || 'N/A'
    },

    // === POIDS ===
    {
      key: 'poids_brut',
      label: 'Poids Brut (kg)',
      category: 'Poids',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.poids_brut || 0
    },
    {
      key: 'poids_tare',
      label: 'Poids Tare (kg)',
      category: 'Poids',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.poids_tare || 0
    },
    {
      key: 'poids_net',
      label: 'Poids Net (kg)',
      category: 'Poids',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.poids_net || 0
    },
    {
      key: 'poids_theorique',
      label: 'Poids Théorique (kg)',
      category: 'Poids',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.poids_theorique || 'N/A'
    },

    // === VÉHICULE ===
    {
      key: 'vehicule_immatriculation',
      label: 'Immatriculation Véhicule',
      category: 'Véhicule',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => weighing.camion_info?.immatriculation || weighing.camion?.immatriculation || 'N/A'
    },
    {
      key: 'vehicule_marque',
      label: 'Marque Véhicule',
      category: 'Véhicule',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.camion_info?.marque || weighing.camion?.marque || 'N/A'
    },
    {
      key: 'vehicule_modele',
      label: 'Modèle Véhicule',
      category: 'Véhicule',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.camion_info?.modele || weighing.camion?.modele || 'N/A'
    },
    {
      key: 'vehicule_proprietaire',
      label: 'Propriétaire Véhicule',
      category: 'Véhicule',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.camion_info?.proprietaire || weighing.camion?.proprietaire || 'N/A'
    },

    // === REMORQUE ===
    {
      key: 'remorque_immatriculation',
      label: 'Immatriculation Remorque',
      category: 'Remorque',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.remorque_info?.immatriculation || weighing.remorque?.immatriculation || 'N/A'
    },
    {
      key: 'remorque_marque',
      label: 'Marque Remorque',
      category: 'Remorque',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.remorque_info?.marque || weighing.remorque?.marque || 'N/A'
    },
    {
      key: 'remorque_modele',
      label: 'Modèle Remorque',
      category: 'Remorque',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.remorque_info?.modele || weighing.remorque?.modele || 'N/A'
    },

    // === CHAUFFEUR ===
    {
      key: 'chauffeur_nom',
      label: 'Nom Chauffeur',
      category: 'Chauffeur',
      required: false,
      defaultSelected: true,
      getValue: (weighing: HistoryPesee) => {
        const chauffeur = weighing.chauffeur_info || weighing.chauffeur;
        return chauffeur ? `${chauffeur.prenom || ''} ${chauffeur.nom || ''}`.trim() : 'N/A';
      }
    },
    {
      key: 'chauffeur_prenom',
      label: 'Prénom Chauffeur',
      category: 'Chauffeur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.chauffeur_info?.prenom || weighing.chauffeur?.prenom || 'N/A'
    },
    {
      key: 'chauffeur_telephone',
      label: 'Téléphone Chauffeur',
      category: 'Chauffeur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.chauffeur_info?.telephone || weighing.chauffeur?.telephone || 'N/A'
    },
    {
      key: 'chauffeur_email',
      label: 'Email Chauffeur',
      category: 'Chauffeur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.chauffeur_info?.email || weighing.chauffeur?.email || 'N/A'
    },

    // === CONVOYEUR ===
    {
      key: 'convoyeur_nom',
      label: 'Nom Convoyeur',
      category: 'Convoyeur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => {
        const convoyeur = weighing.convoyeur_info || weighing.convoyeur;
        return convoyeur ? `${convoyeur.prenom || ''} ${convoyeur.nom || ''}`.trim() : 'N/A';
      }
    },
    {
      key: 'convoyeur_telephone',
      label: 'Téléphone Convoyeur',
      category: 'Convoyeur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.convoyeur_info?.telephone || weighing.convoyeur?.telephone || 'N/A'
    },

    // === CLIENT ===
    {
      key: 'client_nom',
      label: 'Nom Client',
      category: 'Client',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.client_info?.nom || weighing.client?.nom || 'N/A'
    },
    {
      key: 'client_code',
      label: 'Code Client',
      category: 'Client',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.client_info?.code || weighing.client?.code || 'N/A'
    },
    {
      key: 'client_adresse',
      label: 'Adresse Client',
      category: 'Client',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.client_info?.adresse || weighing.client?.adresse || 'N/A'
    },
    {
      key: 'client_telephone',
      label: 'Téléphone Client',
      category: 'Client',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.client_info?.telephone || weighing.client?.telephone || 'N/A'
    },

    // === FOURNISSEUR ===
    {
      key: 'fournisseur_nom',
      label: 'Nom Fournisseur',
      category: 'Fournisseur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.fournisseur_info?.nom || weighing.fournisseur?.nom || 'N/A'
    },
    {
      key: 'fournisseur_code',
      label: 'Code Fournisseur',
      category: 'Fournisseur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.fournisseur_info?.code || weighing.fournisseur?.code || 'N/A'
    },
    {
      key: 'fournisseur_adresse',
      label: 'Adresse Fournisseur',
      category: 'Fournisseur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.fournisseur_info?.adresse || weighing.fournisseur?.adresse || 'N/A'
    },

    // === TRANSPORTEUR ===
    {
      key: 'transporteur_nom',
      label: 'Nom Transporteur',
      category: 'Transporteur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.transporteur_info?.nom || weighing.transporteur?.nom || 'N/A'
    },
    {
      key: 'transporteur_code',
      label: 'Code Transporteur',
      category: 'Transporteur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.transporteur_info?.code || weighing.transporteur?.code || 'N/A'
    },

    // === EXPORTATEUR ===
    {
      key: 'exportateur_nom',
      label: 'Nom Exportateur',
      category: 'Exportateur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.exportateur_info?.nom || weighing.exportateur?.nom || 'N/A'
    },
    {
      key: 'exportateur_code',
      label: 'Code Exportateur',
      category: 'Exportateur',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.exportateur_info?.code || weighing.exportateur?.code || 'N/A'
    },

    // === INFORMATIONS SUPPLÉMENTAIRES ===
    {
      key: 'observations',
      label: 'Observations',
      category: 'Informations supplémentaires',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.observations || ''
    },
    {
      key: 'en_stock',
      label: 'En Stock',
      category: 'Informations supplémentaires',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.en_stock ? 'Oui' : 'Non'
    },
    {
      key: 'created_at',
      label: 'Date de Création',
      category: 'Informations supplémentaires',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.created_at ? new Date(weighing.created_at).toLocaleString('fr-FR') : 'N/A'
    },
    {
      key: 'updated_at',
      label: 'Date de Modification',
      category: 'Informations supplémentaires',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.updated_at ? new Date(weighing.updated_at).toLocaleString('fr-FR') : 'N/A'
    },
    {
      key: 'created_by',
      label: 'Créé par',
      category: 'Informations supplémentaires',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.created_by?.username || weighing.created_by?.nom || 'N/A'
    },
    {
      key: 'updated_by',
      label: 'Modifié par',
      category: 'Informations supplémentaires',
      required: false,
      defaultSelected: false,
      getValue: (weighing: HistoryPesee) => weighing.updated_by?.username || weighing.updated_by?.nom || 'N/A'
    }
  ];
};

// Configuration par défaut pour chaque type d'export
export const getDefaultFieldsForExport = (exportType: 'pdf' | 'excel' | 'csv'): string[] => {
  const allFields = getAvailableExportFields();
  
  switch (exportType) {
    case 'pdf':
      // PDF : champs essentiels pour un rapport concis
      return allFields
        .filter(field => field.defaultSelected || field.required)
        .map(field => field.key);
    
    case 'excel':
      // Excel : plus de détails pour l'analyse
      return allFields
        .filter(field => 
          field.defaultSelected || 
          field.required ||
          field.category === 'Produit' ||
          field.category === 'Poids' ||
          field.category === 'Véhicule' ||
          field.category === 'Chauffeur'
        )
        .map(field => field.key);
    
    case 'csv':
      // CSV : format simple, champs de base
      return allFields
        .filter(field => field.defaultSelected || field.required)
        .map(field => field.key);
    
    default:
      return allFields.filter(field => field.required).map(field => field.key);
  }
};
